import React from "react";
import backgroundImage from "../../../assets/images/main_background.png";
import Grid from "@material-ui/core/Grid";
import HistoryImage from "../../../assets/images/img_history_variz.png";
import Info from "../../../assets/images/info.png";
import WalletCoinSilver from "../../../assets/images/ic_wallet_coin_silver.png";
import WalletCoinGold from "../../../assets/images/ic_wallet_coini.png";
import Toolbar from "../../Toolbar";
import League from "../../../components/pageComponents/Home/LeagueStart/League";
import CustomDialog from "../../pageComponents/Common/Dialog";
import TotalPrize from "../../../components/pageComponents/Home/LeagueStart/TotalPrize";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Mesh from "../../../assets/images/vijee.png";
import Money from "../../../assets/images/money.png";
import GreenButton from "../../../assets/images/green_btn.png";
import GoldCoin from "../../../assets/images/ic_coin.png";
import Rocket from "../../../assets/images/rocket_paye.png";
import Virus from "../../../assets/images/group_3309.png";
import Star from "../../../assets/images/state_star.png";
import PrizeBackground from "../../../assets/images/back.png";
import Key from "../../../assets/images/key.png";
import Lock from "../../../assets/images/lock.png";
import Tamrin from "../../../assets/images/tamrin.png";
import {Redirect, withRouter} from "react-router-dom";
import axios from "axios";
import {giftHallCheck, sessionList, sessionNew, userData} from "../../../Utility/Url";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
import Holder from "../../../assets/images/img_choob.png";
import {connect} from "react-redux";
import {data as rxData} from "../../../Store/Actions/DataAction";
import {
    avatarDialogBackgroundColor,
    avatarDialogContentColor, dialogBackground,
    dialogBorderColor, dialogContentColor,
    dialogContentTextColor
} from "../../../Utility/Theme";
import Progress from "../../ProgressBar";
import PrizeProgress from "../../pageComponents/Home/PrizeProgress";
import TrainingProgress from "../../pageComponents/Home/LeagueStart/TrainingProgress";
import {COINCHANGE} from "../../../Store/Actions/Types";

class LeagueStart extends React.Component{
    constructor() {
        super()
        this.state= {
            appHasLoaded: false,
            time:null,
            leaguesFetched:null,
            allDataLoaded:false,
            dialogDetail:null,
            specialDialogVisible:false,
            specialDialogData:undefined,
            trainDialogVisible:false,
            trainDialogData:null,
            sessionValid:false,
            sessionId:undefined,
            gameType:'blur',
            style: {
                completed: 5,
                root: {
                    flexGrow: 1,
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize:'100% 100%',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor:"#343168",
                    backgroundBlendMode:'soft-light',
                    flex:1,
                    minHeight:'0',
                    overflowY:'hidden'
                },
            }
        }
    }
    sessionList= async()=>{
        await axios.get(sessionList)
            .then(res => {
                const {data}=res
                // if (data.active)
                this.setState({
                    leaguesFetched:data,
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    fetchData= async()=>{
        await axios.get(userData)
            .then(res => {
                const {data}=res
                this.props.rxData(data)
                this.setState({
                    allDataLoaded:true
                })

            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    componentDidMount() {
        this.fetchData()
        this.sessionList()
        this.props.toggleBottomNavbar(false)
        const today=new Date()
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds()
        this.setState({
            time:time
        })
    }
    check=(data)=>{
        const {stars} = this.props.UserData.userData.stats
        // alert(stars)
        const{locked,starRequireToUnlock}=data
        if (data.starRequireToUnlock <= stars){
            this.props.history.push(`/home/total-prizes/${data.game}`)
            return
        }
        // console.log(data)
        const obg ={
            dialog:{
                success:false,
                data:data,
                ok:null,
                message:`برای بازی در این پلن به ${starRequireToUnlock} ستاره نیاز داری `,
                style: {

                    background:avatarDialogBackgroundColor ,
                    borderColor: dialogBorderColor,
                    contentColor:'',
                    contentTextColor: dialogContentTextColor,
                    type: "danger",
                },
                cancel:{
                    action: "#cancel",
                    text: 'باشه'
                }
            }

        }
        this.setState({
            dialogDetail:obg.dialog,
            showDialog:true
        })
    }
    openSpecialLeagueDialog=(data)=>{
        this.setState({
            specialDialogVisible:true,
            specialDialogData: {...data,hasDetails:true}
        })
    }
    closeSpecialDialog=()=>{
        this.setState({
            specialDialogVisible:false,
        })
    }
    handleDialogAction=async (action)=>{
        switch (action) {
            case '#cancel':
                this.setState({
                    showDialog:false,
                    trainDialogVisible:false,
                })
                break
            case '#ok':
                const {special} = this.state.leaguesFetched
                this.setState({
                    showDialog:false,
                    trainDialogVisible:false,

                })
                await axios.post(sessionNew,{
                    id:0,
                    type:'train'
                })
                    .then(res => {
                        const {data}=res
                        // if (!data.success){
                        //     this.setState({
                        //         dialog:data.dialog,
                        //         showDialog:true,
                        //     })
                        //     return false
                        // }
                        // const {startButtonIconText}=this.props.data
                        // this.props.rxData({coinType:'golden',value:startButtonIconText,type:'decrement'},COINCHANGE)
                        this.setState({
                            sessionId:data.sessionID,
                            gameType:'train',
                            sessionValid:true,
                        },()=>{
                            this.setState({
                                sessionValid:true,
                            })
                        })
                        return true
                    }).catch(error=>{
                            console.log(error.toString())
                        }
                    )
                break
            default:
                this.setState({
                    showDialog:false,
                })
        }
    }
    colorSelector=(color)=>{
        let clr=null
        switch (color){
            case 'sabzAbi':
                clr='#00ffb1'
                break
            case 'darkYellow':
                clr='#fbed68'
                break
            case 'fosfori':
                clr='#dfff00'
                break
            case 'lightGreen':
                clr='##2ef972'
                break
            case 'asemooni':
                clr='#bae8ff'
                break
            case 'banafsh':
                clr='#d68dff'
                break
            case 'spPerpuleBg':
                clr='#ff3caa'
                break
            case 'spDarkOrangeBg':
                    clr='#ff7832'
                    break
            case 'darkOrange':
                    clr='#ff7832'
                    break
            case 'spGreenBg':
                    clr='#6eff50'
                    break
            case 'sDarkGreenBg':
                    clr='#2DFFA4'
                    break
            case 'spMaroonBg':
                    clr='#ff323c'
                    break
            case 'spDarkYellowBg':
                    clr='#ffbe3c'
                    break
             case 'spLightYellowBg':
                    clr='#FFF526'
                    break
             case 'spSormeBg':
                    clr='#a082ff'
                    break
             case 'purple2':
                    clr='#560080'
                    break
             case 'spDarkPerpuleBg':
                    clr='#b43cff'
                    break
             case 'spBlueBg':
                    clr='#32ffdc'
                    break
            case 'dark_grey':
                    clr='#444444'
                    break
            case 'black_2':
                    clr='#242424'
                    break
            case 'grayWhite':
                    clr='#A5A5A5'
                    break
            default : clr ='#3c82ff'
        }
        return clr
    }
    openTrainDialog=()=>{
        const {train}=this.state.leaguesFetched
        const obj= {
            dialog:{
                id: 0,
                icon:Info,
                title: "",
                message: train.text,
                ok: {
                    text: "باشه",
                    action: "#ok"
                },
                cancel: {
                    text: "لغو",
                    action: "#cancel"
                },
                style: {
                    type: "danger",
                    borderColor: dialogBorderColor,
                    background: dialogBackground,
                    contentColor: dialogContentColor,
                    contentTextColor: dialogContentTextColor
                }
            }
        }
        this.setState({
            trainDialogData:obj.dialog,
        },()=>{
            this.setState({
                trainDialogVisible:true
            })
        })

    }
    render() {
        const {
            leaguesFetched,
            allDataLoaded,
            dialogDetail,
            specialDialogVisible,
            specialDialogData,
            trainDialogData,
            sessionId,
            sessionValid
        }=this.state
        let trainingData={
            current:undefined,
            max:undefined
        }
        const handleClose=(()=>{
            this.setState({
                showDialog:false,
                trainDialogVisible:false
            })
        })
        const buttons=[
            {
                icon:HistoryImage,
                text:'تاریخچه واریز',
                textColor:'#ffffff',
                direction:'row'
            },
            {
                icon: HistoryImage,
                text: 'تاریخچه کیف پول',
                textColor:'#ffffff',
                direction:'row'
            },
            {
                icon: WalletCoinGold,
                text: 'تبدیل به سکه طلا',
                textColor:'yellow',
                direction:'column'
            },
            {
                icon: WalletCoinSilver,
                text: 'تبدیل سکه به نقره',
                textColor:'#ffffff',
                direction:'column'
            },
        ]
        let specialLeagues=[
             {
                 id:1,
                 name:'لیگ ویژه طلایی اکتشافات',
                 totalPrize:'3.200.000',
                 score:'6820',
                 timeRemaining:this.state.time,
                 backgroundColor:'rgba(231,181,131,0.6)',
                 backgroundImage:Mesh,
                 prizeIcon:Money,
                 startButtonImage:GreenButton,
                 startButtonText:'شروع بازی',
                 startButtonIcon:GoldCoin,
                 startButtonIconText:'20',
                 leftSectionBottomImage:Rocket,
                 leftSectionTopImage:Virus,
                 gameStart:false,
                 currencyFa:'تومن',
                 hasDetails:false


            }
        ]
        let speedyLeagues=[
             {
                id:1,
                name:'لیگ ویژه طلایی اکتشافات',
                totalPrize:'3.200.000',
                score:'6820',
                timeRemaining:this.state.time,
                backgroundColor:'rgba(231,181,131,0.6)',
                backgroundImage:Mesh,
                prizeIcon:Money,
                startButtonImage:GreenButton,
                startButtonText:'شروع بازی',
                startButtonIcon:GoldCoin,
                startButtonIconText:'20',
                leftSectionBottomImage:Rocket,
                leftSectionTopImage:Virus,
                currencyFa:'تومن',
                 hasDetails:false

            }
        ]
        let totalPrizes=[
            {
                name:'مجموع جوایز',
                totalPrize:' 40.000 تومان',
                star:Star,
                score:'0/300',
                prizeIcon:Money,
                backgroundColor:'rgba(201, 87, 30,0.6)',
                backgroundImage:PrizeBackground,
                image:Virus,
                starRequireToUnlock:'270',
                key:Key,
                lock:Lock,
                locked:false,
                gameType:'normal'

            },{
                name:'مجموع جوایز',
                totalPrize:' 40.000 تومان',
                star:Star,
                score:'0/300',
                prizeIcon:Money,
                backgroundColor:'rgba(201, 87, 30,0.6)',
                backgroundImage:PrizeBackground,
                image:Virus,
                starRequireToUnlock:'270',
                key:Key,
                lock:Lock,
                locked:true,
                gameType:'normal'

            }
        ]
        const customDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog:dialogDetail,
            }
        }
        const trainDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog:trainDialogData,
            }
        }
        if (leaguesFetched && allDataLoaded) {
            const {stars} = this.props.UserData.userData.stats
            trainingData={
              ...leaguesFetched.train,
            }
            totalPrizes = leaguesFetched.normal.map(data => {
                return {
                    name: 'مجموع جوایز',
                    totalPrize: `${data.prizeVal} ${data.prizeModel}`,
                    star: Star,
                    score: `${data.currentStars}/${data.allStars}`,
                    prizeIcon: Money,
                    backgroundColor: data.mainColor,
                    backgroundImage: PrizeBackground,
                    image: data.img_v2,
                    starRequireToUnlock: data.requiredStars,
                    key: Key,
                    lock: Lock,
                    locked: data.requiredStars > stars,
                    game:data.game,
                    gameType:'normal',
                }
            })
            specialLeagues=leaguesFetched.special.map(data=> {
                return {
                    ...data,
                    name:data.name,
                    id:data.id,
                    totalPrize:data.prize,
                    score:data.participants,
                    timeRemaining:this.state.time,
                    backgroundColor:this.colorSelector(data.colorName),
                    backgroundImage:Mesh,
                    prizeIcon:Money,
                    startButtonImage:GreenButton,
                    startButtonText:'شروع بازی',
                    startButtonIcon:data.price_url,
                    startButtonIconText:data.price_value,
                    leftSectionBottomImage:Rocket,
                    leftSectionTopImage:data.img_v2,
                    gameType:'special',
                    remSec:data.remSec,
                    currencyFa:data.currencyFa,
                    imageType:'blur'

                }
            })
            speedyLeagues=leaguesFetched.speedy.map(data=> {
                return {
                    ...data,
                    name:data.name,
                    id:data.id,
                    totalPrize:data.prize,
                    score:data.participants,
                    timeRemaining:this.state.time,
                    // backgroundColor:'rgba(231,181,131,0.6)',
                    backgroundColor:this.colorSelector(data.colorName),
                    backgroundImage:Mesh,
                    prizeIcon:Money,
                    startButtonImage:GreenButton,
                    startButtonText:'شروع بازی',
                    startButtonIcon:data.price_url,
                    startButtonIconText:data.price_value,
                    leftSectionBottomImage:Rocket,
                    leftSectionTopImage:data.img_v2,
                    gameType:'special',
                    remSec:data.remSec,
                    currencyFa:data.currencyFa,
                    imageType:'radial'
                }
            })

        }
        return(
            <Grid style={this.state.style.root} direction={"column"} item container>
                {
                    leaguesFetched &&
                    <Grid item sm={12} justify={'center'} container direction={"column"} style={{flex:'1',minHeight:'0',overflowX:'hidden'}}>
                        <Dialog
                            // disableBackdropClick
                            open={this.state.trainDialogVisible}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            style={{background:'transparent !important'}}
                            PaperProps={{
                                style: {
                                    backgroundColor: 'transparent',
                                    boxShadow: 'none',
                                },
                            }}
                        >
                            <DialogContent>
                                <CustomDialog action={this.handleDialogAction} data={trainDialog}/>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={this.state.showDialog}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            style={{background:'transparent !important',overflow:'visible'}}
                            PaperProps={{
                                style: {
                                    backgroundColor: 'transparent',
                                    boxShadow: 'none',
                                    overflow:'visible',
                                },
                            }}
                        >
                            <DialogContent>
                                <CustomDialog action={this.handleDialogAction} data={customDialog}/>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={this.state.specialDialogVisible}
                            onClose={this.closeSpecialDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            style={{background:'transparent !important',overflow:'visible'}}
                            PaperProps={{
                                style: {
                                    backgroundColor: 'transparent',
                                    boxShadow: 'none',
                                    overflow:'visible',
                            },
                            }}
                        >
                            <DialogContent style={{overflow:'visible'}}>
                                <League data={{...specialDialogData, gameStart: true}} />
                            </DialogContent>
                        </Dialog>
                        <Grid item container id={"TTT"}>
                            <Toolbar type='sideToolbar'/>
                        </Grid>
                        <Grid item direction={"column"} container wrap={"nowrap"} className='scrollBar'
                              style={{flex:'1',minHeight:'0',overflow:'auto',overflowX:'hidden'}}>
                            <Grid justify={"center"} container xs={12}  sm={12} >
                                {specialLeagues.map(data=>{
                                    return <Grid item  sm={11} xs={11} style={{marginTop:'50px',marginBottom:''}}
                                        onClick={()=>{
                                            this.openSpecialLeagueDialog(data)}}
                                    >
                                        <League data={data}/>
                                    </Grid>})
                                }
                                {speedyLeagues.map(data=>{
                                    return <Grid item  sm={11} xs={11} style={{marginTop:'50px',marginBottom:''}}
                                        onClick={()=>{this.openSpecialLeagueDialog(data)}}
                                    >
                                        <League data={data} />
                                    </Grid>})
                                }
                                {totalPrizes.map(data=>{
                                    return <Grid item onClick={()=>{
                                        // this.props.history.push('/home/total-prizes')
                                        this.check(data)
                                    }} sm={11} xs={11} style={{marginTop:'50px',marginBottom:''}}>
                                        <TotalPrize prize={data} />
                                        {/*<h1>asdawd</h1>*/}
                                    </Grid>})
                                }
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid justify={"center"} alignItems={"flex-start"} container style={{
                                backgroundImage:`url(${PrizeBackground})`,
                            }}
                                  className='training-section'
                                  onClick={()=>{
                                  if ( leaguesFetched.train.current !== leaguesFetched.train.max)
                                      this.openTrainDialog()
                                  }}
                            >
                                <Grid container justify={"center"} alignItems={"center"} item sm={2} xs={2} style={{backgroundColor:'blue'}}>
                                    <img src={leaguesFetched.train.img} className='training-section-icon' alt=""/>
                                </Grid>
                                <Grid alignItems={"center"} container justify={"center"} item sm={6} style={{
                                    height:'35px',
                                    transform:'translateY(10px)'
                                }}
                                      xs={6}>
                                    <TrainingProgress data={trainingData} />
                                    {/*<p className='training-section-progress'>*/}
                                    {/*    {leaguesFetched.train.current}/{leaguesFetched.train.max}*/}
                                    {/*</p>*/}
                                </Grid>
                                {
                                    leaguesFetched.train.current != leaguesFetched.train.max &&
                                    <Grid xs={11} sm={11} style={{direction:'rtl',marginTop:'-15px'}}>
                                        <p>
                                            {leaguesFetched.train.reward}
                                        </p>
                                    </Grid>
                                }

                            </Grid>
                        </Grid>
                    </Grid>
                }
                {
                    !leaguesFetched &&
                    <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                          style={{
                              position:'relative',
                              top:'50%',
                              left:'50%',
                              transform:'translate(-50%,-50%)'
                          }}>
                        <Grid item container justify={"center"} style={{position:'absolute'}}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>
                }
                { sessionValid &&
                <Redirect
                    to={{
                        pathname: "/league-start/question",
                        state: { sessionId: sessionId,gameType:this.state.gameType}
                    }}
                />
                }
            </Grid>
        )
    }
}
const Lg=withRouter (LeagueStart)

const mapStateToProps=state=>({
    UserData:state.UserData
})
export default connect(mapStateToProps,{rxData})(Lg)
